import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TokenStorage } from 'app/token.storage';

@Pipe({
  name: 'CustomCurrency'
})
export class CustomCurrencyPipe implements PipeTransform {

  constructor(
    public token: TokenStorage
    ){

    }

  transform(
    value: number,
    currencyCode: string = this.token.getProperty().localCurrency.toUpperCase(),
    display:
        | 'code'
        | 'symbol'
        | 'symbol-narrow'
        | string
        | boolean = 'symbol',
    digitsInfo: string = '3.2-2',
    locale: string = 'fr',
): string | null {
    return formatCurrency(
      value,
      locale,
      getCurrencySymbol(currencyCode, 'wide'),
      currencyCode,
      digitsInfo,
    );
}

}
